module.exports = __webpack_public_path__ + "media/images/icon-undestanding-fefc5f55ff46dde33cbe5abfa768b0b4.svg";